/* ------- Google TagManager -------- */

(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f)
})(window,document,'script','dataLayer','GTM-NRP3FT9')

/* ------- Umami ----------- */

const umamiScriptLoad = (umamiId) => {
  let umamiScript = document.createElement('script')
  umamiScript.onload = function () {
    console.log('umami loaded, id:' + umamiId)
  }
  umamiScript.src = 'https://umami.cmog.org/script.js'
  umamiScript.dataset.websiteId = umamiId
  umamiScript.async = true

  document.head.appendChild(umamiScript)
}

umamiScriptLoad('3cdac951-12e3-415a-835d-62a47caa2a84') // Umami Roman Glassblowing website/property
umamiScriptLoad('8199749b-8ed2-4323-98a3-7d0279a3f145') // Umami QR code website/property

function isIOSDevice() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
}

function isDesktopSafari() {
  return /Safari/.test(navigator.userAgent) && (navigator.platform) === 'MacIntel' && (navigator.maxTouchPoints < 1)
}

/* this is a hack for Safari users - IIIF zoom viewer is broken: replace with static image */
function replaceZoomViewer() {
  const zoomAreaContainer = document.getElementsByClassName('quire-entry__lightbox')

  if (zoomAreaContainer.length > 0) {
    const zoomElems = zoomAreaContainer[0].getElementsByTagName('q-lightbox')
    console.log('zoomElems length:' + zoomElems.length)

    // if (zoomElems.length > 0) {
    //   zoomElems[0].remove()
    // }
  }
  // TODO: get static image accession number and use in directory name
  // get file manifest.json
  // TODO: add image to page in place of zoomElem
}

if (isIOSDevice()) {
  document.body.classList.add('device-type--ios')
}

if (isDesktopSafari()) {
  document.body.classList.add('browser--safari')
  replaceZoomViewer()
}